<template>
  <div>
    <div class="card third-party-coupons">
      <div class="card-body">
        <div class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix">
          <b-button
            class="pull-left"
            size="sm"
            variant="primary"
            @click="submitExport()"
          >
            <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
            全部导出
          </b-button>
          <div style="margin-left: 25px" class="pull-left">
            <upload-button
              type="excel"
              text="导入"
              :isFile="true"
              @onSuccess="uploadSuccess"
            ></upload-button>
          </div>

          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.contentKeyword"
              placeholder="请输入搜索内容"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.received"
              class="form-select"
              :options="statusList"
              type="text"
            ></b-form-select>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 70px;">
                    <b-form-checkbox
                      @change="checkedAll"
                      v-model="indeterminate"
                      checked
                      plain
                    ></b-form-checkbox>
                  </th>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" class="w-300">优惠券码</th>
                  <th scope="col">所属平台</th>
                  <th scope="col">领取状态</th>
                  <th scope="col">导入时间</th>
                  <th scope="col"><span class="px-2">操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    <b-form-checkbox
                      v-model="choiceListIds"
                      :value="item.id"
                      checked
                      plain
                    ></b-form-checkbox>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.code }}</td>
                  <td>{{ item.platform || "--" }}</td>
                  <td>
                    <span v-if="item.received == 1">已领取</span>
                    <span v-if="item.received == 0">未领取</span>
                  </td>
                  <td>{{ item.updatedAt || "--" }}</td>
                  <td>
                    <button
                      v-if="item.received != 1"
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="remove(item)"
                    >
                      删除
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination
            :batchs="batchs"
            ref="page"
            @pageCallback="pageCallback"
          ></pagination>
        </div>
        <app-list-loading ref="loading"></app-list-loading>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
import conpon from "../../../../server/api/coupons";
import axios from "axios";

/**
 * Contacts-list component
 */
export default {
  components: {
    pagination,
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        received: "",
        contentKeyword: "",
      },
      items: [],
      index_id: "",
      batchs: [
        //批量操作有哪些操作
        { text: "批量操作", value: "0" },
        { text: "删除", value: "1" },
      ],
      statusList: [
        { text: "筛选状态", value: "" },
        { text: "未领取", value: "0" },
        { text: "已领取", value: "1" },
      ],
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    // 获取详情
    if (this.$route.query.id) {
      this.index_id = this.$route.query.id;
      this.getList();
    }
  },

  created() {},

  methods: {
    //获取列表数据
    getList() {
      let paramsUrl = {
        id: this.index_id,
        page: this.pageParams.page,
        pageSize: this.pageParams.pageSize,
        "q%5Breceived%5D": this.pageParams.received,
        "q%5Bkeywords%5D": this.pageParams.contentKeyword,
      };
      let params = this.utils.getQuery(paramsUrl);
      this.$refs.loading.show();
      this.items = [];
      params.id = this.index_id;
      conpon.codes(params).then((resp) => {
        if (resp.code == 0) {
          if (this.$refs.loading) {
  this.$refs.loading.hide(resp.data.items);
}
          if (resp.data.items) {
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
              if (item.updatedAt) {
                item.updatedAt = this.utils.getTimeStamp(item.updatedAt);
              }
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
              if (this.$refs.page) {
                this.$refs.page.setPages(pages);
              }
            });
          }
        } else {
          if (this.$refs.loading) {
  this.$refs.loading.hide();
}
        }
      });
    },

    submitExport() {
      function createObjectURL(object) {
        return window.URL
          ? window.URL.createObjectURL(object)
          : window.webkitURL.createObjectURL(object);
      }
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      let url =
        env.API_HOST +
        "/create-platform/coupon/codes/export?couponId=" +
        this.index_id;
      xhr.open("get", url);
      xhr.setRequestHeader("x-auth-token", this.cookies.getCookie("token"));
      xhr.responseType = "blob";
      xhr.onload = function(e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = "第三方券码.xlsx";
          console.log(this.response);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement("a");
            var url = createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击删除的处理方法
            this.remove();
          } else {
            Vue.swal("请选择要删除的内容");
            return;
          }
        }
      }
    },

    uploadSuccess(file) {
      console.log(file);
      let formData = new FormData();
      formData.append("file", file);
      formData.append("couponId", this.index_id);
      let headers = {
        "x-auth-token": this.cookies.getCookie("token"),
        "Content-Type": "multipart/form-data",
      };
      let actionApi = env.API_HOST + "/create-platform/coupon/codes/import";
      axios({
        headers: headers,
        url: actionApi,
        method: "post",
        data: formData,
      })
        .then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "导入成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getList();
          } else {
            Vue.swal({
              icon: "error",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.received = "";
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          params.ids = params.ids.toString();
          conpon.removeCouponCode(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal({
                icon: "error",
                title: resp.msg,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.third-party-coupons .app-upload-button .el-upload .el-button {
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}
</style>
